<template>
        <div class="d-flex flex-column justify-content-center align-items-center">
                <div class="card col-md-6">
                        <div class="card-header">
                                <h4 class="card-title text-center

">
                                        Incoming Call
                                </h4>

                        </div>
                        <div class="card-body d-flex flex-column justify-content-center align-items-center">
                                <img :src="call.callerPic" :alt="call.callerName"
                                        class="img-fluid img-thumbnail rounded-circle" style="max-width:80px;">
                                <h4>{{call.callerName}}</h4>
                                <div class="d-flex flex-row">
                                        <button class="btn btn-success" @click="acceptCall">Accept</button>
                                        <button class="btn btn-danger" @click="declineCall">Decline</button>
                                </div>
                        </div>
                </div>
        </div>
</template>

<script>
        import constants from '../config/constants';
        import helper from '../mixins/helper';
        export default {
                data() {
                        return {
                                audio: new Audio("/audio/caller.mp3"),
                                callListener: undefined,
                                call: undefined,
                                isMounted: false,
                        }
                },
                beforeDestroy() {
                        this.audio.pause();
                        this.shutdownListener();
                        this.audio = undefined;
                },
                created() {
                        let $ = this;
                        $.isMounted = true;
                        if (this.$route.params.call == undefined) {
                                this.$router.push('/');
                                $.isMounted = false;
                                return;
                        }
                        this.call = this.$route.params.call;
                        this.playSound();
                        this.updateStatus('ringing');
                        this.callListener = database
                                .ref()
                                .child(`calls`)
                                .child(window.auth_user.id)
                                .child($.call.uuid)
                                .on("value", async (snapshot) => {
                                        if ((snapshot.val() == null || snapshot.val() == undefined)) {

                                                if ($.isMounted) {
                                                        $.$router.go('-1');
                                                        $.isMounted = false;
                                                }

                                        } else if (
                                                snapshot.val().status == "picked_up"
                                        ) {
                                                if ($.isMounted) {
                                                        $.$router.push('/');
                                                        $.isMounted = false;
                                                }
                                        }
                                });
                },

                methods: {
                        updateStatus(status) {
                                database
                                        .ref()
                                        .child(`calls`)
                                        .child(window.auth_user.id)
                                        .child(this.call.uuid).child('status').set(status);
                        },
                        async acceptCall() {
                                let $ = this;
                                $.isMounted = false;
                                let friend = {
                                        'name': this.call.callerName,
                                        'id': this.call.callerId,
                                        'imageUrl': this.call.callerPic
                                }
                                this.shutdownListener();
                                this.updateStatus('picked_up');
                                let params = {
                                        uuid: this.call.uuid,
                                        token: this.call.token,
                                        channel: this.call.channelId,
                                        friend: friend,
                                        authUser: window.auth_user,
                                        wasIncoming: true
                                };
                                helper.eventLog(this.call, constants.eventTypes.accept_incoming);
                                this.$router.push({
                                        name: 'call',
                                        params: params
                                });

                        },
                        async declineCall() {

                                let $ = this;
                                $.isMounted = false;
                                this.updateStatus('declined');
                                let params = {
                                        uuid: this.call.uuid,
                                        token: this.call.token,
                                        channel: this.call.channelId,
                                        friend: friend,
                                        authUser: window.auth_user,
                                        wasIncoming: true
                                };
                                helper.eventLog(this.call, constants.eventTypes.decline_incoming);
                                await this.shutdownListener();
                                this.$router.go('-1');
                        },
                        playSound() {
                                try {
                                        let $ = this;
                                        this.audio.addEventListener(
                                                "ended",
                                                function () {
                                                        $.audio.currentTime = 0;
                                                        $.audio.play();
                                                },
                                                false
                                        );
                                        this.audio.play();
                                } catch (e) {
                                        console.log('Error Playing Audio')
                                }
                        },
                        async shutdownListener() {

                                await database
                                        .ref()
                                        .child(`calls`)
                                        .child(window.auth_user.id)
                                        .child(this.call.uuid).off('value', this.callListener);


                        }
                }
        }
</script>